import React, {useRef} from 'react';
import { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import FillProfileImage from '../../Components/ImagesWithElements/FillProfileImage';
import styled from 'styled-components';
import { Button } from 'antd';
import { Input } from 'antd';
import usePortalService from '../../services/PortalService';
import PdfInput from '../../Components/UploadFiles/PdfInput';
import ErrorMessage from '../../Components/Errors/ErrorMessage';

const { TextArea } = Input;

const Styles = styled.div`
    .progress {
    position: absolute;
    width: 100%;
    height: 6px;
    left: 0px;
    top: 0px;
    background: #2196F3
}
`

export const FillProfileStudent3 = () => {
    const certificatesRef = useRef<any>(null);

    const navigate = useNavigate();

    const {addSkills, profileCommonInformation, aboutMeInformation, error, clearError} = usePortalService();

    const [firstName, setFirstName] = useState('');

    const [aboutMe, setAboutMe] = useState('')

    const [uploadErrorMessage, setUploadErrorMessage] = useState('')

    const aboutMeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setAboutMe(e.target.value)
    }

    useEffect(() => {
        profileCommonInformation().then(result => {
            setFirstName(result.profile.firstName);
        });
        aboutMeInformation().then(result => {
            setAboutMe(result.aboutMeProfile.aboutMe);
        })
    }, []);

    const handleContinue = async (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        try {
            clearError();
            setUploadErrorMessage('');
            if (certificatesRef.current) {
                await certificatesRef.current.save();
            }
            const result = await addSkills({
                aboutMe
            });

            if (result.success) {
                navigate("/home");
            }
        } catch (err) {
            if (err instanceof Error && err.name === "SizeError") {
                setUploadErrorMessage("Ошибка! Превышен допустимый размер файлов для отправки.");
            }
        }
    }

    return (
        <>
            <div className="main-container">
                <section className="auth-sidebar d-none d-md-block">
                    <FillProfileImage firstName={firstName} />
                </section>
                <div className="content" >
                    <div className="auth-content">
                        <p className="step"> Шаг 3 из 3 </p>
                        <h1 style={{ marginBottom: '32px' }}> Ключевые навыки заслуги </h1>
                        <Form>
                            <div className="form-group">
                                <Form.Label> Обо мне </Form.Label>
                                <TextArea
                                    value={aboutMe}
                                    onChange={aboutMeHandler}
                                />
                            </div>
                            <div className="form-group">
                                <Form.Label> Дипломы и сертификаты </Form.Label>
                                <PdfInput
                                    ref={certificatesRef}
                                />
                            </div>
                            <br />
                            {(error || uploadErrorMessage) && <ErrorMessage message={error ?? uploadErrorMessage} />}
                            <Button type="primary" onClick={handleContinue}> Продолжить </Button>
                            <Button type="text" onClick={() => navigate("/home")}> Пропустить </Button>
                        </Form>
                    </div>
                </div>
            </div>
            <Styles>
                <div className="progress"></div>
            </Styles>
        </>
    );
};